"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";

interface BlogNavActionsProps {
  backHref?: string;
}

export function BlogNavActions({ backHref = "/blog" }: BlogNavActionsProps) {
  const router = useRouter();

  const handleGoBack = () => {
    if (window.history.length > 1) {
      router.back();
      return;
    }

    router.push(backHref);
  };

  return (
    <div className="flex flex-wrap items-center gap-3">
      <Button
        type="button"
        variant="outline"
        onClick={handleGoBack}
        className="border-zinc-300 bg-white text-zinc-900 hover:bg-zinc-100"
      >
        Volver
      </Button>
      <Button
        type="button"
        asChild
        variant="outline"
        className="border-zinc-300 bg-white text-zinc-900 hover:bg-zinc-100"
      >
        <Link href="/">Ir al inicio</Link>
      </Button>
    </div>
  );
}
